<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 lg12>
      <v-card class="elevation-0">
        <v-card-title>
          <div class="headline font-weight-medium">
            Prescription Details:
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-combobox
            :items="potency"
            v-model="dlgModel.Potency"
            label="Potency:"
            name="potency"
            v-validate="{ required: true }"
            :error="!!errors.has('potency')"
            :error-messages="errors.first('potency')"
          >
          </v-combobox>

          <v-text-field
            v-model.number="dlgModel.DurationInMonth"
            name="duration"
            label="Duration (in month):"
            v-validate="{ required: true }"
            :error="!!errors.has('duration')"
            :error-messages="errors.first('duration')"
          ></v-text-field>
          <v-autocomplete
            :items="dosage"
            v-model="dlgModel.Dosage"
            label="Dosage:"
            name="dosage"
            item-text="Text"
            item-value="Id"
            v-validate="{ required: true }"
            :error="!!errors.has('dosage')"
            :error-messages="errors.first('dosage')"
          >
          </v-autocomplete>
        </v-card-text>
        <br />
        <v-divider></v-divider>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 lg12>
      <v-card class="elevation-0">
        <v-card-title>
          <div class="headline font-weight-medium">
            Payment Details:
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!--<v-text-field-->
          <!--v-model.trim="dlgModel.ModeOfPayment"-->
          <!--name="payMode"-->
          <!--label="Mode of Payment:"-->
          <!--v-validate="{ required: true }"-->
          <!--:error="!!errors.has('payMode')"-->
          <!--:error-messages="errors.first('payMode')"-->
          <!--&gt;</v-text-field>-->
          <v-radio-group
            row
            label="Mode of payment:"
            v-model="dlgModel.ModeOfPayment"
          >
            <v-radio label="Cash" value="Cash"></v-radio>
            <v-radio label="RTGS" value="RTGS"></v-radio>
            <v-radio label="NEFT" value="NEFT"></v-radio>
            <v-radio label="Card" value="Card"></v-radio>
            <v-radio label="Cheque" value="Cheque"></v-radio>
            <v-radio label="DD" value="DD"></v-radio>
          </v-radio-group>
          <v-text-field
            v-model.trim="dlgModel.TransactionDetails"
            label="Transaction Details:"
          ></v-text-field>
          <v-text-field
            v-model.number="dlgModel.Amount"
            name="Amount"
            label="Amount:"
            v-validate="{ required: true }"
            :error="submit.error"
            :error-messages="errors.first('Amount')"
          >
            <template slot="prepend-inner">
              <v-icon class="filterIcon grey--text text--darken-1"
                >fa fa-rupee-sign</v-icon
              >
            </template>
          </v-text-field>
          <v-dialog
            ref="sptDtMenu"
            v-model="sptDtMenu"
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              name="paymentDate"
              label="Payment Date:"
              v-model="dlgModel.PaymentDate"
              append-icon="fa fa-calendar-alt"
              readonly
              v-validate="{ required: true }"
              :error="submit.error"
              :error-messages="errors.first('paymentDate')"
            >
            </v-text-field>
            <v-date-picker
              v-model="dlgModel.PaymentDate"
              scrollable
              @input="sptDtMenu = false"
            >
            </v-date-picker>
          </v-dialog>
        </v-card-text>
        <br />
        <v-divider></v-divider>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 lg12>
      <v-card class="elevation-0">
        <v-card-text>
          <div class="pContentHeading">
            Disclaimer:&emsp; I confirm that SLIT will be carried out by trained
            personnel in the clinic or hospital where it is equipped with
            necessary emergency kits.
          </div>
          <v-checkbox
            v-model="dlgModel.AgreedToDisclaimer"
            label="I agree to the disclaimer."
          >
          </v-checkbox>
          <div v-show="submit.error">
            <v-list two-line>
              <v-list-tile>
                <span class="red--text">{{ submit.message }}</span>
              </v-list-tile>
            </v-list>
          </div>
        </v-card-text>
        <br />
        <v-divider></v-divider>
        <br />
        <v-card-actions>
          <v-btn
            color="primary"
            @click.native="saveDlg"
            :loading="submit.working"
          >
            <v-icon class="iconText">fa fa-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import WebH from "../../api/web";
export default {
  props: ["patient", "spt", "prescription"],
  data() {
    return {
      potency: ["2800 BU"],
      dosage: [
        { Id: 0, Text: "Daily once" },
        { Id: 1, Text: "Daily twice" }
      ],
      dlgShow: false,
      dlgModel: {
        Potency: "",
        DurationInMonth: 0,
        ModeOfPayment: "Cash",
        BankName: "",
        Branch: "",
        AccountNumber: "",
        Amount: "",
        PaymentDate: "",
        Dosage: 0,
        PatientId: 0,
        SptId: 0,
        AgreedToDisclaimer: false
      },
      submit: {
        error: false,
        working: false,
        message: ""
      },
      sptDtMenu: false
    };
  },

  watch: {
    prescription: function() {
      if (this.prescription) {
        this.dlgModel = {
          Potency: "",
          DurationInMonth: 0,
          ModeOfPayment: "Cash",
          TransactionDetails: "",
          Amount: "",
          PaymentDate: "",
          Dosage: 0,
          PatientId: this.patient.Id,
          SptId: this.spt.Id,
          AgreedToDisclaimer: false
        };
      } else {
        this.dlgModel = {
          Potency: "",
          DurationInMonth: 0,
          ModeOfPayment: "Cash",
          TransactionDetails: "",
          Amount: "",
          PaymentDate: "",
          Dosage: 0,
          PatientId: 0,
          SptId: 0,
          AgreedToDisclaimer: false
        };
      }
    }
  },
  methods: {
    // changePaymentMode() {
    //   if (this.dlgModel.ModeOfPayment === "Cash") {
    //     //this.dlgModel.ModeOfPayment = "Cash";
    //     this.dlgModel.BankName = "Cash";
    //     this.dlgModel.Branch = "Cash";
    //     this.dlgModel.AccountNumber = "Cash";
    //   } else {
    //     //this.dlgModel.ModeOfPayment = "Net Banking";
    //     this.dlgModel.BankName = "";
    //     this.dlgModel.Branch = "";
    //     this.dlgModel.AccountNumber = "Net Banking";
    //   }
    // },
    clearDlg() {
      //this.errors.clear();
      this.dlgShow = false;
      this.dlgModel = {
        Potency: this.prescription.Potency,
        DurationInMonth: this.prescription.DurationInMonth,
        ModeOfPayment: this.prescription.ModeOfPayment,
        TransactionDetails: this.prescription.TransactionDetails,
        Amount: this.prescription.Amount,
        PaymentDate: "",
        Dosage: this.prescription.Dosage,
        PatientId: this.patient.Id,
        SptId: this.spt.Id,
        AgreedToDisclaimer: false
      };
      this.submit = {
        error: false,
        working: false,
        message: ""
      };
      this.$validator.reset();
    },
    async saveDlg() {
      if (!this.dlgModel.AgreedToDisclaimer) {
        await this.$notifyDlg.show(
          "You have to agree to the disclaimer",
          "Warning",
          "warning"
        );
        return;
      }
      const res = await this.$validator.validateAll();
      if (!res) return;
      if (!this.patient.Id) return;
      if (!this.spt.Id) return;
      this.dlgModel.PatientId = this.patient.Id;
      this.dlgModel.SptId = this.spt.Id;
      this.submit.working = true;
      this.api_addPrescription(this.dlgModel);
      //this.dlgShow = true;
    },
    confirmDlg() {
      this.dlgShow = false;
    },
    async api_addPrescription(data) {
      const loader = this.$loading.show();
      const res = await WebH.Post("/prescriptions", data);
      this.submit.working = false;
      loader.hide();
      if (res.Success) {
        this.$notify({
          type: "info",
          text: "Successfully generated new prescription"
        });
        await this.$notifyDlg.show(
          "Successfully generated prescription",
          "Information",
          "info"
        );
        this.clearDlg();
        this.$emit("clearFields");
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    }
  }
};
</script>

<style scoped></style>
